import React from "react";
import { Clock } from "lucide-react";

const TimeSelector = ({
  value,
  onChange,
  label,
}: {
  value: string;
  onChange: (val: string) => void;
  label: string;
}) => {
  // Parse existing value or default
  const parseTime = (timeStr: string) => {
    if (!timeStr) return { hour: "09", minute: "00", period: "AM" };
    const [time, period] = timeStr.split(" ");
    const [hour, minute] = time ? time.split(":") : ["09", "00"];
    return {
      hour: hour || "09",
      minute: minute || "00",
      period: period || "AM",
    };
  };

  const { hour, minute, period } = parseTime(value);

  const updateTime = (key: string, val: string) => {
    let newHour = hour;
    let newMinute = minute;
    let newPeriod = period;

    if (key === "hour") {
      const cleanedVal = val.replace(/\D/g, "").slice(0, 2);
      if (cleanedVal === "") {
        newHour = "";
      } else {
        const num = parseInt(cleanedVal);
        newHour = num > 12 ? "12" : cleanedVal;
      }
    }
    if (key === "minute") {
      const cleanedVal = val.replace(/\D/g, "").slice(0, 2);
      if (cleanedVal === "") {
        newMinute = "";
      } else {
        const num = parseInt(cleanedVal);
        newMinute = num > 59 ? "59" : cleanedVal;
      }
    }
    if (key === "period") newPeriod = val;

    onChange(`${newHour || "00"}:${newMinute || "00"} ${newPeriod}`);
  };

  const handleBlur = () => {
    const formattedHour = hour.padStart(2, "0");
    const formattedMinute = minute.padStart(2, "0");
    if (formattedHour !== hour || formattedMinute !== minute) {
      onChange(`${formattedHour}:${formattedMinute} ${period}`);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      <label
        style={{
          fontSize: "11px",
          color: "#64748B",
          fontWeight: 600,
          letterSpacing: "0.5px",
          textTransform: "uppercase",
        }}
      >
        {label}
      </label>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          background: "#FFF",
          border: "1px solid #E2E8F0",
          borderRadius: "8px",
          padding: "4px",
          height: "40px",
          gap: "4px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        }}
      >
        <Clock size={14} color="#94A3B8" style={{ marginLeft: "4px" }} />

        {/* Hour Input */}
        <input
          type="text"
          value={hour}
          onChange={(e) => updateTime("hour", e.target.value)}
          onBlur={handleBlur}
          placeholder="HH"
          style={{
            border: "none",
            outline: "none",
            fontSize: "14px",
            color: "#334155",
            fontWeight: 500,
            background: "transparent",
            textAlign: "center",
            width: "24px",
            padding: 0,
          }}
        />

        <span style={{ color: "#CBD5E1", margin: "0 -2px" }}>:</span>

        {/* Minute Input */}
        <input
          type="text"
          value={minute}
          onChange={(e) => updateTime("minute", e.target.value)}
          onBlur={handleBlur}
          placeholder="MM"
          style={{
            border: "none",
            outline: "none",
            fontSize: "14px",
            color: "#334155",
            fontWeight: 500,
            background: "transparent",
            textAlign: "center",
            width: "24px",
            padding: 0,
          }}
        />

        {/* Period Select */}
        <select
          value={period}
          onChange={(e) => updateTime("period", e.target.value)}
          style={{
            border: "none",
            outline: "none",
            fontSize: "12px",
            color: "#475569",
            fontWeight: 600,
            background: "#F1F5F9",
            cursor: "pointer",
            borderRadius: "4px",
            padding: "2px 6px",
            height: "24px",
            marginLeft: "4px",
          }}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div>
  );
};

export default TimeSelector;
